import React, { FunctionComponent, useState, useEffect, useRef } from "react";
import * as PropTypes from 'prop-types';

import { IconMan, IconWoman } from '../utils/icons';

//@ts-ignore
import ReactSlider from 'react-slider';

import { LocationInput } from './';
import { Search } from '../models';

export interface SearchProps {
    search: Search;
    ageMax: number;
    ageMin: number;
    onChange: ((search: Search) => void);
}

export const SearchForm = ({ search, ageMax, ageMin, onChange }: SearchProps) => {
    const [state, setState] = useState(search);

    const firstRender = useRef(true);

    useEffect(() => {
        if (firstRender.current === true) {
            firstRender.current = false;
            return;
        }
        onChange(state);
    }, [state]);

    useEffect(() => {
        setState(search);
    }, [search]);

    return <div className="app-search">
        <form name="pazintys" action="/ngrupe.cfm">
            <div className="app-paz-s1 app-flex"><strong>Noriu susipažinti su:</strong>
                <div className="app-paz-s1-r">
                    <span className={`men __men ${state.genderMale === true ? 'active' : null}`} title="vyrais"
                        onClick={() => setState({ ...state, genderMale: !state.genderMale })}><IconMan /> vaikinu</span>
                    <span className={`women __women ${state.genderFemale === true ? 'active' : null}`} title="moterimis"
                        onClick={() => setState({ ...state, genderFemale: !state.genderFemale })}><IconWoman /> mergina</span>
                </div>
            </div>

            <div className="app-paz-s2"><span>{state.ageFrom}</span> - <span className="__age1">{state.ageTo}</span> m.</div>
            <div className="app-paz-s3 app-flex">
                <strong>Dominantis amžius:</strong>
                <ReactSlider
                    className="slider"
                    thumbClassName="slider-thumb"
                    trackClassName="slider-track"
                    defaultValue={[state.ageFrom, state.ageTo]}
                    min={ageMin} max={ageMax} pearling
                    onChange={(val: number[]) => setState({ ...state, ageFrom: val[0], ageTo: val[1] })}
                    renderThumb={(props: any) => <div {...props}></div>}
                />
            </div>

            <div className="app-paz-s4 app-flex">
                <strong>Vietovė:</strong>
                <div className="app-paz-s4-r">
                    <LocationInput
                        defaultValue={search.location}
                        onSelected={(location) => { setState({ ...state, location: location }) }} />
                </div>
            </div>

            <input type="hidden" name="amzius" value={state.ageFrom} />
            <input type="hidden" name="amzius2" value={state.ageTo} />
            <input type="hidden" name="lytis" value={state.genderFemale && !state.genderMale ? '1' : state.genderMale && !state.genderFemale ? '2' : ''} />
            <input type="hidden" name="vietove" value={state.location.id} />
            <input type="hidden" name="vietovep" value={state.location.display64} />

            <div className="app-paz-s5 app-flex">
                <a href="/npaieska.cfm">Daugiau kriterijų</a>
                <button className="button button-large button-red" type="submit">Ieškoti</button>
            </div>
        </form>
    </div >;
}